export const isCabinet = window.location.href.indexOf('cabinet') !== -1;
